export default function UnderstandingSETASection() {
  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Understanding SETA Compliance
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The Skills Development Act requires employers with an annual payroll exceeding R500,000 to contribute 1% of their payroll to skills development through the Skills Development Levy (SDL).
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="space-y-6">
              <div className="bg-gray-50 p-6 rounded-xl">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  What is the Skills Development Levy?
                </h3>
                <p className="text-gray-600 mb-4">
                  The SDL is a mandatory contribution of 1% of your company's annual payroll, collected by SARS and distributed to Sector Education and Training Authorities (SETAs) to fund skills development initiatives.
                </p>
                <div className="bg-[#2D7F3E] text-white p-4 rounded-lg">
                  <p className="font-semibold">Key Fact:</p>
                  <p>Companies can recover up to 70% of their SDL through proper compliance and training initiatives.</p>
                </div>
              </div>

              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-gray-900">Benefits of SETA Compliance:</h4>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Recover significant portions of your skills development levy</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Access additional discretionary funding for training</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Improve your B-BBEE scorecard rating</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                    <span className="text-gray-600">Develop a skilled and productive workforce</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-8 rounded-xl">
            <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
              SDL Breakdown
            </h3>
            
            <div className="space-y-4">
              <div className="bg-white p-4 rounded-lg border-l-4 border-[#2D7F3E]">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-gray-900">Mandatory Grants</span>
                  <span className="text-2xl font-bold text-[#2D7F3E]">20%</span>
                </div>
                <p className="text-sm text-gray-600">Available through WSP and ATR submissions</p>
              </div>

              <div className="bg-white p-4 rounded-lg border-l-4 border-amber-500">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-gray-900">Discretionary Grants</span>
                  <span className="text-2xl font-bold text-amber-600">49.5%</span>
                </div>
                <p className="text-sm text-gray-600">Additional funding through applications</p>
              </div>

              <div className="bg-white p-4 rounded-lg border-l-4 border-green-800">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-gray-900">SETA Administration</span>
                  <span className="text-2xl font-bold text-green-800">10.5%</span>
                </div>
                <p className="text-sm text-gray-600">SETA operational costs</p>
              </div>

              <div className="bg-white p-4 rounded-lg border-l-4 border-brand-muted">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-gray-900">NSF & QCTO</span>
                  <span className="text-2xl font-bold text-brand-muted">20%</span>
                </div>
                <p className="text-sm text-gray-600">National Skills Fund allocation</p>
              </div>
            </div>

            <div className="mt-6 p-4 bg-[#2D7F3E] text-white rounded-lg text-center">
              <p className="font-semibold">Total Recoverable: Up to 69.5%</p>
              <p className="text-sm text-green-100">Through proper compliance and applications</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}